import { Button } from "@mui/material";

export default function SubmitButton({
                                         message,
                                         sx,
                                         disabled = false,
                                     }) {
    return (
        <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            sx={sx}
            disabled={disabled}
        >
            {message}
        </Button>
    );
}
